export const getImageUrlFromString = (content: string): string | null => {
  const match = content.match(/<img[^>]+src="([^">]+)"/i);

  // Return index 1 of the match array, which contains the URL
  return match ? match[1] : null;
};
